import React, {Component} from "react";
import {Form, Spinner} from "react-bootstrap";
import Strings from "../../../config/Strings";
import {TigerButton} from "../../../global/tiger-button/TigerButton";
import {withToast} from "../../../util/ToastService";
import './TigerpostB2B.css';
import GlobalConstants from "../../../config/GlobalConstants";
import {Link} from "react-router-dom";

class TigerpostB2B extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            email: null,
            error: false
        };
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
    }

    //Submitting
    async submitForm(e) {
        e.preventDefault();

        if (this.state.email == null || this.state.email === "") {
            this.setState(prevState => ({...prevState, error: true}));
            return;
        }

        this.setState(prevState => ({...prevState, loading: true}));

        let result = await fetch(GlobalConstants.SPINE_HOST +  'api/newsletter/merchant/subscribe?email=' + this.state.email, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(function(response) {
                return response;
            })
            .catch(function (error) {
                console.log("Error: " + error);
                return error;
            });

        if (result.ok) {
            this.props.addToast(Strings.TIGERPOST_B2B_SUCCESS, {autoDismiss: true, appearance: "success"});
        } else {
            this.props.addToast(Strings.TIGERPOST_B2B_ERROR, {autoDismiss: true, appearance: "error"});
        }

        this.setState(prevState => ({...prevState, loading: false}));
    }

    //Rendering
    render() {
        return (
            <div className="tigerpost-container">
                <div className="tigerpost-title">{Strings.TIGERPOST_B2B_TITLE}</div>
                <div className="tigerpost-info" dangerouslySetInnerHTML={{__html: Strings.TIGERPOST_B2B_INFO}} />
                <Form className="tigerpost-form" onSubmit={(e) => this.submitForm(e)}>
                    {/* E-Mail */}
                    <Form.Group className="mb-3" controlId="tigerpostB2BEmail">
                        <Form.Label className="auth-label">E-Mail-Adresse</Form.Label>
                        <Form.Control
                            type="email"
                            value={this.state.email}
                            isInvalid={this.state.error}
                            onChange={e => this.setState(prevState => ({
                                ...prevState,
                                email: e.target.value
                            }))} />
                        <Form.Control.Feedback type="invalid">
                            {Strings.CONTRACT_CANCELLATION_ERROR_EMAIL}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <TigerButton className="tigerpost-button" variant="red"
                                 disabled={this.state.loading}>
                        {this.state.loading ?
                            <Spinner animation="border"/>
                            :
                            Strings.TIGERPOST_B2B_BUTTON}
                    </TigerButton>
                </Form>
                <div className="tigerpost-dsgvo"><Link to={"/" + GlobalConstants.APP_PATH + "haendler/tigerpost-abmeldung"} style={{textDecoration: "underline"}}>Hier</Link> kannst du dich jederzeit abmelden oder klicke auf den Abmeldelink, den Du am Ende eines jeden Newsletter findest.<br />
                Weitere Informationen findest du in unserer <a href="https://tiger.media/policies/terms-of-service" style={{textDecoration: "underline"}}>Datenschutzerklärung</a>.</div>
            </div>
        )
    }
}

export default withToast(TigerpostB2B);